import { Editor } from "slate";
import { CustomElement } from "../../../../slate";
import { generateCode as generateCodeSource } from "../../../api/data";

export const generateCode = generateCodeSource;

export const createWithVoidInjector = (elementType: string) => (editor: Editor) => {
    const { isVoid } = editor;
    editor.isVoid = (element: CustomElement) => {
        return element.type === elementType ? true : isVoid(element);
    }
    
    return editor;
}